import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { App } from './App';
import { ApiError } from './lib/api';
import { ToastProvider } from './ui/toast';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    // Always try the request. In the default mode a query that starts while the device is offline is *paused*: it is
    // neither loading nor failed, so screens fell through to their empty states ("No visitors") instead of an error.
    mutations: { networkMode: 'always' },
    queries: {
      networkMode: 'always',
      staleTime: 10_000,
      refetchOnWindowFocus: true,
      // Client errors (4xx) will not fix themselves; network blips will.
      retry: (count, err) => !(err instanceof ApiError && err.status >= 400 && err.status < 500) && count < 2,
    },
  },
});

// Auto-updating service worker: new versions activate on next launch without a store release.
registerSW({ immediate: true });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <App />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
